(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["collection-slider-single"] && !window.DesignMode) return;
  try {
    
const slider = document.querySelector('.single-collection-slider');
const next = slider.querySelector('#single-slider-next');
const prev = slider.querySelector('#single-slider-prev');
const slideContainer = slider.querySelector('.slider');

next.addEventListener('click', () => {
  slideContainer.scroll({
    left: slideContainer.scrollLeft + slideContainer.offsetWidth,
    behavior: 'smooth'
  });
});

prev.addEventListener('click', () => {
  slideContainer.scroll({
    left: slideContainer.scrollLeft - slideContainer.offsetWidth,
    behavior: 'smooth'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    // Function to change the image src
    function changeImageSrc() {
        let image = document.getElementById("responsiveFooterImg");
        
        if (window.innerWidth <= 749) {
            image.src = "https://cdn.shopify.com/s/files/1/0544/6139/9227/files/mobile-trust-badges.png?v=1691579564";
        } else {
            image.src = "https://cdn.shopify.com/s/files/1/0544/6139/9227/files/Trust-badge_3.png?v=1691578534";
        }
    }

    // Initially set the image src
    changeImageSrc(); 

    // Update the image src on window resize
    window.addEventListener("resize", changeImageSrc);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tabs"] && !window.DesignMode) return;
  try {
    

  // Activate the first tab
window.addEventListener('DOMContentLoaded', (event) => {
  const firstTab = document.querySelector('.tab-link');
  if (firstTab) {
    firstTab.click();
  }
});

document.querySelectorAll('.tab-link').forEach((tab) => {
  tab.addEventListener('click', (event) => {
    // Remove active class from all tabs
    document.querySelectorAll('.tab-link').forEach((tab) => {
      tab.classList.remove('active');
    });

    // Hide all "View All" buttons
    document.querySelectorAll('.tab-content .view-all-button').forEach((btn) => {
      btn.style.display = 'none';
    });

    // Add active class to clicked tab
    tab.classList.add('active');

    document.querySelectorAll('.tab-content').forEach((tabContent) => {
      tabContent.style.display = 'none'; // Hide all tab contents
    });

    document.getElementById(event.target.dataset.tab).style.display = 'block'; // Show the clicked tab content

    // Get and show the "View All" button inside the clicked tab's content
    const currentTabContent = document.getElementById(event.target.dataset.tab);
    const viewAllButton = currentTabContent.querySelector('.view-all-button');
    if (viewAllButton) {
        viewAllButton.style.display = 'inline-flex'; 
    }
  });
});

// Slider functionality
const sliders = Array.from(document.querySelectorAll('.tab-slider-component'));

sliders.forEach(slider => {
  const next = slider.querySelector('#tab-slider-next');
  const prev = slider.querySelector('#tab-slider-prev');
  const slideContainer = slider.querySelector('.slider');

  next.addEventListener('click', () => {
  slideContainer.scroll({
    left: slideContainer.scrollLeft + slideContainer.offsetWidth,
    behavior: 'smooth'
  });
});

  prev.addEventListener('click', () => {
  slideContainer.scroll({
    left: slideContainer.scrollLeft - slideContainer.offsetWidth,
    behavior: 'smooth'
  });
});
});


  } catch(e) { console.error(e); }
})();
      })();
